var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pc-page-loading",attrs:{"role":"status","aria-live":"polite"}},[_c('div',{staticClass:"loading-box"},[_c('span',{staticClass:"loading-spinner"}),_c('strong',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }